<!--elementUI 图标选择器-->
<template>
  <div >
    <el-dialog title="更新缩略图" :visible.sync="dialogVisible" destroy-on-close class="custom_dialog_class" width="50%" min-width="500px" top="8vh">
        <el-form :data="addImgform">
          <el-row :gutter="20">
            <el-col v-if="type=='item'" :span="12">
              <el-form-item label="图片" prop="itemFileUrl" label-width="120px">
                <el-image
                  style="width: 160px; height: 120px"
                  :preview-src-list="[addImgform.itemFileUrl]"
                  :src="addImgform.itemFileUrl"
                >
                </el-image>
              </el-form-item>
            </el-col>
            <el-col v-if="type=='product'" :span="12">
              <el-form-item label="封面图片" prop="coverImage" label-width="120px">
                <el-image
                  style="width: 160px; height: 120px"
                  :preview-src-list="[addImgform.coverImage]"
                  :src="addImgform.coverImage"
                >
                </el-image>
              </el-form-item>
              <el-form-item v-if="addImgform.thumbnailImage" label="缩略图" prop="thumbnailImage" label-width="120px">
                <el-image
                  style="width: 160px; height: 120px"
                  :preview-src-list="[addImgform.thumbnailImage]"
                  :src="addImgform.thumbnailImage"
                >
                <div slot="error"></div>
                </el-image>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分享图" prop="shareImage" label-width="120px">
                <el-upload
                  class="avatar-uploaderImage"
                  :action="$uploadURL"
                  :show-file-list="true"
                  :on-success="addChangeImgSuccess"
                >
                  <img
                    v-show="addImgform.shareImage"
                    :src="addImgform.shareImage"
                    class="avatarImage"
                  />
                  <div v-show="!addImgform.shareImage">
                    <i class="el-icon-plus avatar-uploaderImage-icon"></i>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template slot="footer">
            <el-button @click="cancelP">取消</el-button>
            <el-button type="primary" @click="handleConfirm">确定</el-button>
        </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    editImgDialog: {
      type: Boolean,
      default: true
    },
    itemObject: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    updateUrl: {
      type: String,
      default: '/productExtAttrItem/update'
    }
  },
  data () {
    return {
      curPrintList: [],//当前一键打印列表
      // dialogVisible: false,//一键打印弹窗
      startPrint: false,//开始打印
      type: 'item',
      addImgform: {
        id: "",
        itemFileUrl: "",
        itemName: "",
        coverImage: '',
        shareImage: '',
      },
    }
  },
  computed: {
    dialogVisible: {
      // getter
      get: function () {
        return this.editImgDialog
      },
      // setter
      set: function (newValue) {
        this.$emit('update:visible', false)
      }
    }
  },
  watch: {
    editImgDialog: {
      handler (val) {
        if(val){
          this.initForm()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 初始化
    initForm(){
      if(this.updateUrl == '/productExtAttrItem/update'){
        this.type = 'item'
      }else{
        this.type = 'product'
      }
      console.log('类型：',this.type)
      this.addImgform = Object.assign({},this.itemObject)
    },
    cancelP(){
        this.$emit('update:visible', false)
        this.addImgform = {}
    },
    // 缩略图片编辑上传
    addChangeImgSuccess(res, file) {
      this.addImgform.shareImage = res.data.url;
      // this.addImgform.itemName = res.data.fileName;
    },
    handleConfirm () {
      // this.$emit('handleOCPrint', this.selectPrintObject)
      // this.$emit('update:visible', false)
      if(!this.addImgform.shareImage){
        this.$message.error('请上传分享图');
        return
      }
      var that = this;
      this.$confirm("确定更新分享图吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(()=>{
        const _data = {
          id: this.addImgform.id,
          shareImage: this.addImgform.shareImage,
        }
        const _url = this.updateUrl
        console.log("this.addImgform", this.addImgform,_url);
        that.$http
        .post(_url, _data)
        .then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "更新成功",
              showClose: true,
            });
            that.cancelP();
            that.$emit('siconfirm',true)
          } else {
            that.$notify.info({
              title: "提示",
              message: response.data.message,
              showClose: true,
            });
          }
        });
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-uploaderImage ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploaderImage .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploaderImage-icon {
  font-size: 28px;
  color: #8c939d;
  width: 160px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatarImage {
  width: 160px;
  height: 120px;
  display: block;
}
</style>
